import { MatchConfigViewModel, PeriodViewModel } from '@/types/view-models/match-config'
import { PeriodSetup, MatchConfig } from 'match-central-shared/src/types/match-config'
import { numericFromTime, prettifyTimeFromNumeric } from 'match-central-shared/dist/utility/time'

/**
 * Convert period setup to view model
 * @param {PeriodSetup} periodSetup
 * @returns
 */
function convertPeriodSetupToViewModel(periodSetup: PeriodSetup): PeriodViewModel {
  return {
    quantity: periodSetup.quantity,
    duration: prettifyTimeFromNumeric(periodSetup.duration),
    allowExtraTime: periodSetup.allowExtraTime,
  }
}

/**
 * Convert period setup from view model to config
 * @param {PeriodSetup} periodSetup
 * @returns
 */
function convertPeriodSetupToConfig(periodSetup: PeriodViewModel): PeriodSetup {
  return {
    quantity: periodSetup.quantity,
    duration: numericFromTime(periodSetup.duration),
    allowExtraTime: periodSetup.allowExtraTime,
  }
}

/**
 * Convert config to view model
 *
 * @param {MatchConfig} c
 * @returns
 */
export function convertConfigToViewModel(c: MatchConfig): MatchConfigViewModel {
  return {
    regularPeriods: convertPeriodSetupToViewModel(c.regularPeriods),

    overtimePeriods:
      c.overtimePeriods === null ? null : convertPeriodSetupToViewModel(c.overtimePeriods),

    penalties: c.penalties,
  }
}

/**
 * Convert view model to config
 * @param vm
 * @returns
 */
export function convertViewModelToConfig(vm: MatchConfigViewModel): MatchConfig {
  return {
    regularPeriods: convertPeriodSetupToConfig(vm.regularPeriods),

    overtimePeriods:
      vm.overtimePeriods === null ? null : convertPeriodSetupToConfig(vm.overtimePeriods),

    penalties: vm.penalties,
  }
}
